import { Loading } from '@/components/Loading'
import Step2Wrapper from '@/containers/steps/property/Step2/Step2Wrapper'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { OffersPropertyProvider } from '@/context/OffersPropertyProvider'
import { QuotesProvider } from '@/context/QuotesContext'
import { SidebarProvider } from '@/context/SidebarContext'
import { StepsProvider } from '@/context/StepsContext'
import { WizzardHeaderProvider } from '@/context/WizzardHeaderContext'
import { WithAuth } from '@/hoc/WithAuth'
import { useApp } from '@/hooks/useApp'
import { useEffect } from 'react'

const Step2PageComponent = () => {
  const { product, setProduct } = useApp()
  const { insuranceParams, isLoadingData } = useInsuranceParams()

  useEffect(() => {
    if (insuranceParams?.generalParams?.insuranceCategoryType)
      setProduct(insuranceParams?.generalParams?.insuranceCategoryType)
  }, [insuranceParams?.generalParams?.insuranceCategoryType])

  return (
    <StepsProvider currentStepId={2}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          <QuotesProvider>
            {(isLoadingData) && <Loading large={true} />}
            {insuranceParams && product == insuranceParams.generalParams.insuranceCategoryType &&
              <OffersPropertyProvider>
                <Step2Wrapper />
              </OffersPropertyProvider>
            }
          </QuotesProvider>
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}

export const Step2Page = WithAuth(Step2PageComponent)